const CUSTOMER_DISPLAY_MAIN_APP_PRESENCE_LOCK =
  'customer-display-main-app-presence'

const getLockManager = () => globalThis.navigator?.locks
const getPresenceLockName = tabId =>
  tabId
    ? `${CUSTOMER_DISPLAY_MAIN_APP_PRESENCE_LOCK}:${tabId}`
    : CUSTOMER_DISPLAY_MAIN_APP_PRESENCE_LOCK

const getCustomerDisplayPresenceLockNames = async () => {
  const lockManager = getLockManager()
  if (typeof lockManager?.query !== 'function') return null

  try {
    const { held = [] } = await lockManager.query()
    return held.map(lock => lock.name)
  } catch (error) {
    console.warn('No se pudo validar la presencia de la app principal:', error)
    return null
  }
}

export const acquireCustomerDisplayMainAppPresence = tabId => {
  const lockManager = getLockManager()
  const lockName = getPresenceLockName(tabId)
  if (typeof lockManager?.request !== 'function') return null

  let releaseLock
  let released = false
  const releasePromise = new Promise(resolve => {
    releaseLock = resolve
  })

  lockManager
    .request(lockName, { mode: 'shared' }, async () => {
      if (released) return
      await releasePromise
    })
    .catch(error => {
      console.warn(
        'No se pudo registrar la presencia de la app principal:',
        error
      )
    })

  return () => {
    if (released) return

    released = true
    releaseLock()
  }
}

export const hasCustomerDisplayMainAppPresence = async (
  tabId,
  heldLockNamesSnapshot
) => {
  const lockName = getPresenceLockName(tabId)
  const heldLockNames =
    heldLockNamesSnapshot ?? (await getCustomerDisplayPresenceLockNames())

  return heldLockNames === null ? null : heldLockNames.includes(lockName)
}

export const getCustomerDisplayMainAppPresenceState = async ownerTabId => {
  const heldLockNames = await getCustomerDisplayPresenceLockNames()
  if (heldLockNames === null) return null

  const ownerLockName = getPresenceLockName(ownerTabId)
  const tabLockPrefix = `${CUSTOMER_DISPLAY_MAIN_APP_PRESENCE_LOCK}:`
  const ownerIsPresent = await hasCustomerDisplayMainAppPresence(
    ownerTabId,
    heldLockNames
  )

  return {
    ownerIsPresent,
    anotherTabIsPresent: heldLockNames.some(
      lockName =>
        lockName.startsWith(tabLockPrefix) && lockName !== ownerLockName
    ),
  }
}
